import { ConditionalFeature, Feature } from '@sona/shared-model-common';

export const ConditionalFeatures = {
    DeepScansCredits: {
        key: 'deep_scans',
        condition: (options) => options.meter?.includes('credits') && options.maxCredits > 0
    },
    DeepScansStarterAudits: {
        key: 'deep_scans',
        condition: (options) => options.meter?.includes('starterAudits')
    }
} satisfies Record<string, ConditionalFeature<Feature>>;
